const GET_PROPERTY_TYPES = 'publicador/step1Module1/GET_PROPERTY_TYPES';
const GET_PROPERTY_TYPES_COMPLETED = 'publicador/step1Module1/GET_PROPERTY_TYPES_COMPLETED';
const GET_PROPERTY_TYPES_FAILED = 'publicador/step1Module1/GET_PROPERTY_TYPES_FAILED';
const SET_PROPERTY_TYPE = 'publicador/step1Module1/SET_PROPERTY_TYPE';

const GET_PROPERTY_SUBTYPES = 'publicador/step1Module1/GET_PROPERTY_SUBTYPES';
const GET_PROPERTY_SUBTYPES_COMPLETED = 'publicador/step1Module1/GET_PROPERTY_SUBTYPES_COMPLETED';
const GET_PROPERTY_SUBTYPES_FAILED = 'publicador/step1Module1/GET_PROPERTY_SUBTYPES_FAILED';
const SET_PROPERTY_SUBTYPE = 'publicador/step1Module1/SET_PROPERTY_SUBTYPE';
const SET_REDIRECT_FROM_APPRAISAL = 'publicador/step4Module1/SET_REDIRECT_FROM_APPRAISAL';

const GET_FORM_VALUES = 'publicador/step1Module1/GET_FORM_VALUES';
const GET_FORM_VALUES_COMPLETED = 'publicador/step1Module1/GET_FORM_VALUES_COMPLETED';

const SET_OPERATION_TYPE = 'publicador/step1Module1/SET_OPERATION_TYPE';

const SAVE_STEP1_MODULE_1 = 'publicador/step1Module1/SAVE_MODULE_1';
const SAVE_STEP1_MODULE_1_COMPLETED = 'publicador/step1Module1/SAVE_MODULE_1_COMPLETED';
const SAVE_STEP1_MODULE_1_FAILED = 'publicador/step1Module1/SAVE_MODULE_1_FAILED';

const SET_EDIT_VALUES = 'publicador/step1Module1/SET_EDIT_VALUES';
const SET_DISABLED_BRANCH = 'publicador/step1Module1/SET_DISABLED_BRANCH';

const CLEAN_VALUES = 'publicador/step1Module1/CLEAN_VALUES';

export {
  GET_PROPERTY_TYPES,
  GET_PROPERTY_TYPES_COMPLETED,
  GET_PROPERTY_TYPES_FAILED,
  GET_PROPERTY_SUBTYPES,
  GET_PROPERTY_SUBTYPES_COMPLETED,
  GET_PROPERTY_SUBTYPES_FAILED,
  SET_PROPERTY_TYPE,
  SET_PROPERTY_SUBTYPE,
  SET_OPERATION_TYPE,
  SAVE_STEP1_MODULE_1,
  SAVE_STEP1_MODULE_1_COMPLETED,
  SAVE_STEP1_MODULE_1_FAILED,
  SET_EDIT_VALUES,
  GET_FORM_VALUES,
  GET_FORM_VALUES_COMPLETED,
  SET_DISABLED_BRANCH,
  CLEAN_VALUES,
  SET_REDIRECT_FROM_APPRAISAL
};
